import ReactApexChart from "react-apexcharts";

export default function CallsPerDayChart({ labels, values }) {
  return (
    <ReactApexChart
      type="area"
      height={200}
      series={[{ name: "Calls", data: values }]}
      options={{
        chart: {
          type: "area",
          height: 200,
          toolbar: { show: false },
          fontFamily: "'Outfit', sans-serif",
          background: "transparent",
        },
        xaxis: {
          categories: labels,
          labels: { style: { colors: "#9ca3af", fontSize: "10px" } },
        },
        yaxis: {
          labels: { style: { colors: "#9ca3af", fontSize: "10px" } },
        },
        colors: ["#18A0D8"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [0, 100],
          },
        },
        stroke: { curve: "smooth", width: 2.5 },
        dataLabels: {
          enabled: true,
          style: { fontSize: "10px", colors: ["#6b7280"] },
          offsetY: -6,
        },
        grid: { borderColor: "#e8f2f7", strokeDashArray: 3 },
        tooltip: { theme: "light" },
      }}
    />
  );
}
